/* eslint-disable no-underscore-dangle */
import { WPRequest } from 'wpapi';

import { sleep } from '@blockworks/platform/utils';

export interface WpCollection<T> extends Array<T> {
    _paging?: {
        total: number;
        totalPages: number;
        links?: {
            next?: WPRequest;
            prev?: WPRequest;
        };
    };
}

export interface LargeDataRequest {
    baseReq: WPRequest;
    limit: number;
    page?: number;
}

const createRequestWrapper = (pageLimit: number) => {
    return async <T>({ baseReq, limit, page = 1 }: LargeDataRequest): Promise<WpCollection<T> | null> => {
        const baseOffset = (page - 1) * limit;
        const perPage = Math.min(pageLimit, limit);
        const numReqs = Math.ceil(limit / perPage);
        const res: any[] = [];
        let retry = null;
        let retryCount = 0;

        for (let i = 0; i < numReqs; i += 1) {
            const reqOffset = i * perPage;
            const remainder = limit - reqOffset;

            const req = baseReq
                .offset(baseOffset + reqOffset)
                .perPage(limit - reqOffset < perPage ? remainder : perPage)
                .page(1);
            const reqUrl = req.toString();
            try {
                const data = await req.get();
                res.push(data);
            } catch (err) {
                if (retry === reqUrl && retryCount > 1) {
                    throw new Error(`Failed to fetch ${retry}`);
                }
                retry = reqUrl;
                retryCount += 1;
                console.log('Retrying: ', reqUrl);
                i -= 1;
            }
            // Allow other requests to process
            if (process.env.CI || retry === reqUrl) {
                await sleep(5000);
            }
        }

        return res.flat().filter(Boolean);
    };
};
export default createRequestWrapper;
